import { render } from "./Historia.vue?vue&type=template&id=3596d2a6"
import script from "./Historia.vue?vue&type=script&lang=js"
export * from "./Historia.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Szymon\\witryny\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__